import type { ImageItem } from './impls/image-selector-dialog-service';

/**
 * 获取可选择图片选项
 */
export interface GetAvailableImagesOptions {
    /** 任务ID */
    taskId?: string;
    /** 最大返回数量 */
    maxCount?: number;
    /** 图片类型过滤 */
    imageTypes?: string[];
}

/**
 * 图片提供服务接口
 * 负责获取可供用户选择的图片列表
 */
export interface ImageProviderService {
    /**
     * 获取可选择的图片列表
     * @param options 获取选项
     * @returns 可选择的图片列表
     */
    getAvailableImages(options?: GetAvailableImagesOptions): Promise<ImageItem[]>;
}

export const ImageProviderService = Symbol.for('ImageProviderService');
